import { configureStore } from '@reduxjs/toolkit';
import {
  useDispatch as useReduxDispatch,
  useSelector as useReduxSelector,
} from 'react-redux';
import { persistStore, persistReducer } from 'redux-persist';
import { rootPersistConfig, rootReducer } from './rootReducer';
import ws from './middleware/ws';

const store = configureStore({
  reducer: persistReducer(rootPersistConfig, rootReducer),
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: false,
    }).concat([ws]),
});

const { dispatch } = store;
const useSelector = useReduxSelector;
const useDispatch = () => useReduxDispatch();
const persistor = persistStore(store);

export { store, persistor, dispatch, useSelector, useDispatch };
